module.exports = __webpack_public_path__ + "media/assets/trash-42b0a673d264160c4c9d6f1e707eb356a68e32f2545b59158fa66b8538084548.svg";